import { DAYS } from './constants';
import { FormSection } from '../../components/ui/FormSection';
import type { OperatingHours } from './constants';

interface OperatingHoursSectionProps {
  operatingHours: OperatingHours;
  onOperatingHoursChange: (
    day: string,
    field: 'open' | 'close' | 'closed',
    value: string | boolean
  ) => void;
  operatingHoursNotes: string;
  onOperatingHoursNotesChange: (value: string) => void;
  operatingHoursValidated: boolean;
  onOperatingHoursValidatedChange: (value: boolean) => void;
}

export const OperatingHoursSection = ({
  operatingHours,
  onOperatingHoursChange,
  operatingHoursNotes,
  onOperatingHoursNotesChange,
  operatingHoursValidated,
  onOperatingHoursValidatedChange,
}: OperatingHoursSectionProps) => (
  <FormSection title="Operating Hours">
    <div className="space-y-3">
      {DAYS.map((day) => (
        <div key={day} className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
          <label className="capitalize font-medium text-gray-700">{day}</label>

          <div className="flex items-center">
            <input
              type="checkbox"
              checked={operatingHours[day].closed ?? false}
              onChange={(e) => onOperatingHoursChange(day, 'closed', e.target.checked)}
              className="mr-2"
            />
            <span className="text-sm text-gray-600">Closed</span>
          </div>

          {!operatingHours[day].closed && (
            <>
              <input
                type="time"
                value={operatingHours[day].open}
                onChange={(e) => onOperatingHoursChange(day, 'open', e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
              />
              <input
                type="time"
                value={operatingHours[day].close}
                onChange={(e) => onOperatingHoursChange(day, 'close', e.target.value)}
                className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
              />
            </>
          )}
        </div>
      ))}
    </div>

    <div className="mt-4">
      <label htmlFor="operatingHoursNotes" className="block text-sm font-medium text-gray-700 mb-1">
        Operating Hours Notes
      </label>
      <textarea
        id="operatingHoursNotes"
        value={operatingHoursNotes}
        onChange={(e) => onOperatingHoursNotesChange(e.target.value)}
        rows={2}
        placeholder="e.g., Closed on major holidays"
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
      />
    </div>

    <div className="mt-4 flex items-start gap-2">
      <input
        id="operatingHoursValidated"
        type="checkbox"
        checked={operatingHoursValidated}
        onChange={(e) => onOperatingHoursValidatedChange(e.target.checked)}
        className="mt-1"
      />
      <label htmlFor="operatingHoursValidated" className="text-sm text-gray-700">
        <span className="font-medium">Hours verified</span>
        <span className="block text-xs text-gray-500">
          Check this once you've confirmed the hours are accurate (e.g. by calling or visiting). Public pages show a small "not yet verified" note when this is off.
        </span>
      </label>
    </div>
  </FormSection>
);
